// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Confirm_wrapper__3CGla","Container":"Confirm_Container__25WNi","border":"Confirm_border__1YqWP","close":"Confirm_close__3VMFp"};